import styled from 'styled-components/native';

const Component = styled.StatusBar.attrs({
  hidden: true,
  showHideTransition: 'fade',
})``;

Component.displayName = 'HiddenStatusBar';

export default Component;
